var isRetinaDisplay = function () {
  if (window.matchMedia) {
    var mq = window.matchMedia(
      "only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)"
    );
    return (mq && mq.matches) || window.devicePixelRatio > 1;
  }
};
$(function () {
  if (isRetinaDisplay()) {
    $("html").addClass("retina");
  }
});

var swap_lg_for_sm = function () {
  if ($("html").hasClass("retina")) {
    $("img[data-original]").attr("data-original", function (i, original) {
      //console.log("handle retina replacing:", original);
      return original.replace(/_sm\.|_md\./, "_lg.");
    });
  }
};
// splash?
if (typeof window.Turbolinks == "undefined") {
  $(() => swap_lg_for_sm);
} else {
  $(document).on("turbolinks:load", swap_lg_for_sm);
}
